import { Injectable } from '@angular/core';
@Injectable()
export class ToasterService {
  constructor() {
    /**/
  }
  public StartToaster(message: any, AutoStop: boolean, timeout?: number) {
    const x = document.getElementById('snackbar');
    x.innerText = message;
    x.style.left = '50%';
    x.style.bottom = '50%';
    x.style.right = '50%';
    if (AutoStop) {
      setTimeout(
        function () {
          x.className = x.className.replace('show', '');
        },
        timeout ? timeout : 3000
      );
    }
    x.className = 'show';
  }
  public StopToaster() {
    const x = document.getElementById('snackbar');
    x.className = '';
    x.innerText = '';
  }
}
